export default "__VITE_ASSET__C3ITx5EI__"